import { FC } from "react";
import { AppBar, Toolbar, IconButton, Typography, Box, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { Profile } from "../Profile";
import { NoSignal } from "../NoSignal";
import { getAppBarColor } from "./envColor";
import { useUIMode } from "../../wms/src/context/UIContext";

interface Props {
  showMenu: boolean;
  isOpen?: boolean;
  onMenu: () => void;
  selectedName?: string | null;
}

export const Header: FC<Props> = ({ showMenu, isOpen, onMenu, selectedName }) => {
  const env = import.meta.env.VITE_ENV;
  const { isMobile, isCollapsed, toggleCollapsed } = useUIMode();

  return (
    <AppBar
      sx={(theme) => ({
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: getAppBarColor(env, theme),
        width: "100%",
        left: 0,
        right: 0
      })}
    >
      <Toolbar 
        variant="dense" 
        sx={{ 
          minHeight: 55, 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          px: { xs: 1, sm: 2 },
          width: "100%",
          boxSizing: "border-box"
        }}
      >
        {/* Left Section */}
        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          {showMenu && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={onMenu}
            >
              <MenuIcon />
            </IconButton>
          )}

          <Box
            sx={{
              display: {
                xs: isOpen ? "flex" : "none",
                sm: "flex",
              },
              alignItems: "center",
            }}
          >
            <img
              src="https://wabi-south-central-us-c-primary-redirect.analysis.windows.net/powerbi/resource/images/1/fc902332-a1eb-4292-adaf-3cab2d850620/20/BlobIdV2-ca6eeaf5-eb3e-493d-92ed-4347c234ed0evXGaMwoNQTVOx-Rks369v2D-rwCu4Ddk5gT.png"
              alt="WMS Logo"
              style={{
                height: "26px",
                marginRight: "10px",
                marginLeft: showMenu ? "0px" : "1px",
              }}
            />
            <Typography variant="h6" noWrap>
              WMS
            </Typography>
          </Box>

          {/* Botón para colapsar/expandir el menú (solo desktop) */}
          {!isMobile && (
            <Tooltip title={isCollapsed ? "Expandir menú" : "Contraer menú"}>
              <IconButton
                onClick={toggleCollapsed}
                color="inherit"
                sx={{
                  ml: 1.5,
                  p: 0.75,
                  borderRadius: 1.5,
                  backgroundColor: "rgba(255,255,255,0.15)",
                  transition: "background-color 0.2s",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.3)" },
                }}
              >
                <ReadMoreIcon
                  sx={{
                    fontSize: 26,
                    transform: isCollapsed ? "none" : "scaleX(-1)",
                  }}
                />
              </IconButton>
            </Tooltip>
          )}
        </Box>

        {/* Center Section */}
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            minWidth: 0,
            overflow: "hidden",
            px: 1
          }}
        >
          {selectedName && (
            <Typography 
              variant="h6" 
              noWrap 
              sx={{ 
                display: {
                  xs: !isOpen ? "flex" : "none",
                  sm: "flex",
                },
                textAlign: "center" 
              }}
            >
              {selectedName}
            </Typography>
          )}
        </Box>

        {/* Right Section */}
        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0, gap: 0.5 }}>
          <NoSignal />
          <Profile />
        </Box>
      </Toolbar>
    </AppBar>
  );
};